import React from 'react'

interface ITrophyIconProps {
  size?: number
  color?: string
  style?: React.CSSProperties
}

/**
 * Troféu em SVG porque a classe `lni lni-trophy` **não existe no LineIcons 4.0** — o `::before`
 * sai com `content: none` e o ladrilho do ícone fica vazio. O `RevenueCard` já tinha este SVG
 * local pelo mesmo motivo; o `EventDetailPage` ainda usava a classe quebrada.
 */
export default function TrophyIcon({ size = 16, color = 'currentColor', style }: ITrophyIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flexShrink: 0, display: 'inline-block', verticalAlign: 'middle', ...style }}
    >
      <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
      <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
      <path d="M4 22h16" />
      <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
      <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
      <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
    </svg>
  )
}
